
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 30 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M29.268 25.739l-5.806-5.806c3.932-5.888 2.348-13.85-3.54-17.782C14.036-1.78 6.075-.198 2.143 5.69c-3.933 5.888-2.35 13.849 3.538 17.781a12.818 12.818 0 0014.247-.002l5.806 5.805a2.532 2.532 0 003.535 0c.991-.96 1.045-2.515.084-3.507-.02-.02-.038-.038-.084-.028zM12.813 3.756A9.063 9.063 0 113.75 12.82a9.072 9.072 0 019.063-9.063z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h30v30H0z"}})])])])
          )
        }
      }
    